import loader from '../helpers/loader';

export default {
  async getAvailableNotifications() {
    return loader.getJSON(`/api/notifications/available`)
  }
}
